<div class="quote-list-container">
  <div class="page-header">
    <h2>Quotes</h2>
  </div>

  <!-- Search and Filter Bar -->
  <div class="search-filter-bar">
    <div class="search-input-wrapper">
      <input
        type="text"
        class="search-input"
        placeholder="Search by Quote ID, Product ID or Product Name"
        [(ngModel)]="searchTerm"
        (input)="onSearch()"
        (keyup)="onSearch()">
      <svg class="search-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="9" cy="9" r="6" stroke="#6b7280" stroke-width="1.5"/>
        <path d="M14 14L17 17" stroke="#6b7280" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
    </div>
    
    <select class="filter-select" [(ngModel)]="selectedCategory" (change)="onCategoryChange()">
      <option value="">Filter by Product Category</option>
      <option *ngFor="let cat of categories" [value]="cat.name">{{ cat.name }}</option>
    </select>
    
    <select class="filter-select" [(ngModel)]="selectedStatus" (change)="onStatusChange()">
      <option value="">Filter by Status</option>
      <option value="Active">Active</option>
      <option value="Expired">Expired</option>
    </select>
    
    <button class="btn-reset" (click)="resetFilters()">Reset</button>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="loading-state">
    <p>Loading quotes...</p>
  </div>

  <!-- Quotes Table -->
  <div *ngIf="!loading && filteredQuotes.length > 0" class="table-container" #tableContainer>
    <table class="quotes-table">
      <thead>
        <tr>
          <th>Quote ID</th>
          <th>Supplier ID</th>
          <th>Product ID</th>
          <th>Product</th>
          <th>Timeline (DD/MM/YYYY)</th>
          <th>Shipping Detail</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let quote of filteredQuotes" (click)="viewQuote(quote)" class="table-row-clickable">
          <td class="quote-id-cell">
            <div class="quote-id-text">{{ quote.quoteId || '-' }}</div>
            <span class="status-badge-small" [ngClass]="getSupplierValidDateStatusClass(quote.supplierValidDateStatus)">
              {{ getSupplierValidDateStatusText(quote.supplierValidDateStatus) }}
            </span>
          </td>
          <td class="quote-id-cell">
            <div class="quote-id-text" *ngIf="!this.isSupplier"  (click)="viewSupplier(quote?.supplier); $event.preventDefault(); $event.stopPropagation()">{{ quote?.supplier?.supplierId || '-' }} ({{quote?.supplier?.country || '-'}})
            <svg class="external-link-icon" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 2V8M10 2H4M10 2L2 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              </div>
              <div class="quote-id-text" *ngIf="this.isSupplier">{{ quote?.supplier?.supplierId || '-' }} ({{quote?.supplier?.country || '-'}})
                  </div>
            <span  *ngIf="quote?.supplier?.companyName">
              CompanyName:{{ quote?.supplier?.companyName || '-' }}
            </span>
          </td>
          <td class="product-id">{{ quote.product?.productId || '-' }}</td>
          <td class="product-name">
            <div class="product-name-text">{{ quote.product?.name || '-' }}</div>
            <div class="product-category" *ngIf="quote.category?.name || quote.product?.category?.name">
              Product category: {{ quote.category?.name || quote.product?.category?.name }}
            </div>
          </td>
          <td class="timeline">
            <div class="timeline-item">
              <span class="timeline-label">Quoted on :</span>
              <span class="timeline-value">{{ formatDate(quote.submittedAt || quote.submittedOn) }}</span>
            </div>
            <div class="timeline-item">
              <span class="timeline-label">Valid Upto :</span>
              <span class="timeline-value">{{ formatDate(quote.validityDate || quote.validUpto) }}</span>
            </div>
          </td>
          <td class="shipping-detail">
            <div class="shipping-term-text">{{ getShippingTerm(quote) }}</div>
            <div class="shipping-address">{{ getShippingAddress(quote) }}</div>
          </td>
        </tr>
      </tbody>
    </table>
    
    <!-- Infinite Scroll Loading Indicator -->
    <div class="infinite-scroll-loader" *ngIf="isLoadingMore">
      <div class="loader-spinner"></div>
      <span>Loading more quotes...</span>
    </div>
    
    <!-- End of Data Message -->
    <div class="end-of-data" *ngIf="!hasMoreData && !loading && filteredQuotes.length > 0">
      <p>No more quotes to load</p>
    </div>
  </div>

  <div class="empty-state" *ngIf="!loading && filteredQuotes.length === 0">
    <p>No quotes found</p>
  </div>
</div>
